/* eslint-disable*/
import React from "react";
import { getFullMonthNameWithYear } from "@utils/utils";
import { getPronoun, getPosessivePronoun } from "@utils/utils";

const EmployeeCertificate = ({
  name,
  gender,
  cnic,
  position,
  joiningDate,
  months,
}) => {
  return (
    <div>
      <p style={wrapper}>
        This is to certify that <span style={boldStyle}>{name}</span> holder of
        CNIC <span style={boldStyle}>{cnic}</span> is working with our reputed
        company as a <span style={boldStyle}>{position}</span>.
        {getPronoun(gender)} has been working with us since{" "}
        <span style={boldStyle}>{getFullMonthNameWithYear(joiningDate)}</span>{" "}
        and has proved to be a very dedicated resource who has been very loyal
        to the company. {getPosessivePronoun(gender)} salary for the last{" "}
        <span style={boldStyle}>{months}</span> months is as under. Salary
        transferred through IBFT from company account.
      </p>
    </div>
  );
};

const wrapper = {
  marginTop: "15px",
};
const boldStyle = {
  fontWeight: "bold",
};

export default EmployeeCertificate;
